import React from "react";

const CARNET_NOTE_PATH =
  "M890 1522 c-26 -14 -51 -46 -97 -123 -34 -57 -78 -129 -97 -160 l-34 " +
  "-56 -89 -6 c-163 -11 -260 -63 -319 -172 -35 -65 -129 -415 -140 -522 -6 -54 " +
  "-4 -60 21 -85 17 -18 38 -28 56 -28 16 0 29 -3 29 -7 0 -5 -7 -77 -16 -162 " +
  "-21 -213 -27 -210 161 -91 109 69 156 105 181 139 40 55 41 65 9 107 -33 43 " +
  "-80 71 -144 85 -45 9 -56 9 -69 -4 -21 -22 0 -47 40 -47 34 0 95 -29 122 -59 " +
  "18 -20 18 -21 -7 -54 -22 -29 -234 -174 -242 -165 -2 2 3 70 11 152 l14 149 " +
  "72 120 72 119 13 -38 c17 -47 31 -63 220 -234 154 -139 201 -171 296 -196 105 " +
  "-28 168 -17 322 56 134 62 126 37 123 376 l-3 289 -150 108 c-82 59 -164 114 " +
  "-182 122 l-32 15 55 99 c71 130 72 156 7 221 -68 68 -138 86 -203 52z m152 " +
  "-78 c55 -53 54 -64 -8 -177 -31 -56 -58 -103 -59 -105 -2 -2 -57 2 -123 9 " +
  "-117 12 -121 13 -110 33 40 77 153 258 166 266 31 19 101 5 134 -26z m-426 " +
  "-341 c-4 -9 -35 -64 -69 -122 -35 -58 -101 -171 -147 -251 -163 -283 -177 " +
  "-305 -192 -308 -9 -2 -22 4 -31 12 -13 13 -13 24 -1 86 17 89 91 386 106 423 " +
  "20 51 67 105 113 133 56 33 92 42 169 43 50 1 57 -1 52 -16z m315 0 c10 -10 " +
  "-106 -232 -125 -239 -7 -3 -69 -3 -139 -2 l-127 3 77 129 76 129 115 -6 c63 " +
  "-3 118 -9 123 -14z m261 -121 l153 -108 3 -259 c3 -306 13 -280 -139 -345 -96 " +
  "-41 -103 -42 -182 -38 -119 7 -168 35 -362 213 -177 163 -195 186 -174 231 27 " +
  "55 44 57 280 24 118 -17 226 -30 241 -30 23 0 30 8 57 74 35 85 38 101 14 110 " +
  "-22 9 -28 1 -57 -69 -18 -44 -29 -60 -43 -58 -10 1 -100 13 -200 27 -202 29 " +
  "-245 31 -274 15 -19 -9 -19 -9 -10 10 11 19 22 21 179 23 l167 3 56 105 c95 " +
  "175 98 180 119 180 11 0 88 -49 172 -108z";

export default function CarnetNoteIcon({
  size = 24,
  color = "currentColor",
  strokeWidth = 1,
  onClick,
  className,
  style = {},
  ...rest
}) {
  const mergedStyle = Object.assign(
    { width: size, height: size, cursor: onClick ? "pointer" : undefined },
    style
  );

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 143 155"
      width={size}
      height={size}
      fill={color}
      stroke="none"
      onClick={onClick}
      className={className}
      style={mergedStyle}
      aria-hidden={rest["aria-label"] ? undefined : true}
      {...rest}
    >
      <g transform="translate(0,155) scale(0.1,-0.1)">
        <path d={CARNET_NOTE_PATH} />
      </g>
    </svg>
  );
}
